// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3113ac9a","455":"07377c3d","977":"4bb8517e"}[chunkId] + ".chunk.js";
};